const givePlannerMinHeight = (modulePlanner) => {
  if (!modulePlanner) {
    return;
  }

  if (window.innerWidth <= 1024) {
    modulePlanner.style.minHeight = "auto";
    return;
  }

  const plannerNavigation = modulePlanner.querySelector(
    ".module-planner__navigation.visible"
  );

  if (plannerNavigation) {
    const navigationHeight = plannerNavigation.offsetHeight;
    modulePlanner.style.minHeight = navigationHeight + "px";
  }
};

export { givePlannerMinHeight };
